import anime from 'animejs'
import charming from 'charming'

const SELECTORS = {
  linkWords: '.link-words',
  linkLetters: '.link-letters'
}


export default class Link {
  constructor () {
    this.linkWords   = Array.from( RM.Select.el(SELECTORS.linkWords) );
    this.linkLetters = Array.from( RM.Select.el(SELECTORS.linkLetters) );
    RM.BM(this, ['onAppInit', 'onAppLoaded', 'onAppLoadedEnded', 'onAppResize']);

    if (this.linkWords.length || this.linkLetters.length) {
      this.init();
    }
  }

  init () {
    this.linkWords.forEach( item => new LinkHover(item, 'word') );
    this.linkLetters.forEach( item => new LinkHover(item, 'letter') );
  }

  onAppInit() {
  }

  onAppLoaded() {
  }

  onAppLoadedEnded() {
  }

  onAppResize() {
  }
}

class LinkHover {
  constructor (el, type) {
    this.DOM          = {}
    this.DOM.el       = el
    this.animateWords = true
    this.colors       = {
      initial: null,
      active: window.getComputedStyle(this.DOM.el).getPropertyValue('--hover-item-color')
    }

    if (type == 'word') {
      charming(this.DOM.el, {
        split: function (string) {
          return string.split(/(\s+)/)
        },
        setClassName: function (index) {
          return `word-${index}`
        }
      })
    } else {
      charming(this.DOM.el)
      this.animateWords = false
    }

    this.DOM.letters       = Array.from( RM.Select.queryAll('span', this.DOM.el) )
    this.colors.initial    = window.getComputedStyle(this.DOM.letters[0]).color
    this.delay             = this.animateWords ? 20 : 7
    this.duration          = 200
    this.DOM.hoverSelector = el.dataset.linkHoverSelector ? document.querySelector(el.dataset.linkHoverSelector) : this.DOM.el

    this.initEvents()
  }

  initEvents () {
    this.mouseenterFn = () => this.mouseTimeout = setTimeout(() => {
      this.isActive = true
      anime.remove(this.DOM.letters)
      anime({
        targets: this.DOM.letters,
        delay: (t,i) => i * this.delay,
        translateY: [
          { value: 10, duration: this.duration, easing: 'easeInQuad' },
          { value: [-10,0], duration: this.duration, easing: 'easeOutQuad' }
        ],
        opacity: [
          { value: 0, duration: this.duration, easing: 'linear' },
          { value: 1, duration: this.duration, easing: 'linear' }
        ],
        color: {
          value: this.colors.active,
          duration: 1,
          delay: (t,i,l) => i * this.delay + this.duration
        }
      })
    }, 50)

    this.mouseleaveFn = () => {
      clearTimeout(this.mouseTimeout)
      if ( !this.isActive )
        return
      this.isActive = false

      anime.remove(this.DOM.letters)
      anime({
        targets: this.DOM.letters,
        delay: (t,i,l) => (l - i - 1) * this.delay,
        translateY: [
          { value: 10, duration: this.duration, easing: 'easeInQuad' },
          { value: [-10,0], duration: this.duration, easing: 'easeOutQuad' }
        ],
        opacity: [
          { value: 0, duration: this.duration, easing: 'linear' },
          { value: 1, duration: this.duration, easing: 'linear' }
        ],
        color: {
          value: this.colors.initial,
          duration: 1,
          delay: (t,i,l) => (l - i - 1) * this.delay + this.duration
        }
      })
    }

    RM.L(this.DOM.hoverSelector, 'a', 'mouseenter', this.mouseenterFn)
    RM.L(this.DOM.hoverSelector, 'a', 'touchstart', this.mouseenterFn)
    RM.L(this.DOM.hoverSelector, 'a', 'mouseleave', this.mouseleaveFn)
    RM.L(this.DOM.hoverSelector, 'a', 'touchend', this.mouseleaveFn)
  }
}
